module.exports = __webpack_public_path__ + "img/ico-ch.245d9640.png";